import * as React from "react";
import {useEffect, useRef} from "react";
import {DimensionamentoService} from "../../services/DimensionamentoServices";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import IconButton from "@mui/material/IconButton";
import {Add, Remove} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import Collapse from "@mui/material/Collapse";
import {FaMapMarkedAlt} from "react-icons/fa";
import MapModal from "../MapComponents/DimensionamentoMap/MapModal";

const formatValue = (value, isRecommendation = true) => {
  if (typeof value === "string") return value;
  if (typeof value === "number") {
    const roundedValue = isRecommendation
      ? Math.ceil(value)
      : Math.round(value);
    return new Intl.NumberFormat("pt-BR", {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(roundedValue);
  }
  return "-";
};


export default function Row(props) {
  const {row, title, city} = props;
  const [openSubCategories, setOpenSubCategories] = React.useState({});
  const [mainCategoryOpen, setMainCategoryOpen] = React.useState(props.stateOpen)
  const [mapModalOpen, setMapModalOpen] = React.useState(false);
  const [mapData, setMapData] = React.useState(null);
  const [selectedCustomer, setSelectedCustomer] = React.useState(null);

  const prevStateOpenRef = useRef();

  useEffect(() => {
    if (prevStateOpenRef.current !== props.stateOpen) {
      setMainCategoryOpen(props.stateOpen);

      const updatedState =
        row.subCategories?.reduce((acc, subCategory) => {
          acc[subCategory.className] = props.stateOpen;
          return acc;
        }, {}) || {};

      setOpenSubCategories(updatedState);

      prevStateOpenRef.current = props.stateOpen;
    }
  }, [props.stateOpen, row.subCategories]);

  const handleOpenMap = (customerId, customerCode, state) => {
    setSelectedCustomer(customerId);
    setMapModalOpen(true);
    setMapData([]);


    DimensionamentoService.getAttributeMapData(state, customerCode)
      .then((data) => {
        setMapData(data);
      })
      .catch((e) => {
        setMapData([]);
        console.error("Erro ao obter dados do mapa:", e);
      });
  };

  const toggleSubCategory = (className) => {
    setOpenSubCategories(prev => ({
      ...prev,
      [className]: !prev[className]
    }))
  };

  const renderRegionCells = (regionData, bgColor, regionKey) => {
    const {available, expected, result} = regionData;

    const isStringValue =
      typeof available === "string" || typeof expected === "string";

    if (isStringValue) {
      const displayValue = typeof available === "string" ? available : expected;

      return (
        <TableCell
          key={`${regionKey}-merged`}
          colSpan={3}
          align="center"
          sx={{
            borderLeft: "1px solid #f0f0f0",
            borderBottom: "1px solid #f0f0f0",
            padding: "14px 10px",
            backgroundColor: bgColor,
          }}
        >
          <div className="flex items-center justify-center">
            <span className="text-blue-700 px-3 py-1 rounded text-sm font-medium">
              {displayValue}
            </span>
          </div>
        </TableCell>
      );
    }

    return (
      <>
        <TableCell
          key={`${regionKey}-available`}
          sx={{
            borderLeft: "1px solid #f0f0f0",
            borderBottom: "1px solid #f0f0f0",
            padding: "14px 10px",
            backgroundColor: bgColor,
          }}
          align="center"
        >
          <div className="flex items-center justify-center">
            <span className="text-blue-700 px-3 py-1 rounded text-sm font-medium">
              {formatValue(available)}
            </span>
          </div>
        </TableCell>
        <TableCell
          key={`${regionKey}-expected`}
          sx={{
            borderBottom: "1px solid #f0f0f0",
            padding: "14px 10px",
            backgroundColor: bgColor,
          }}
          align="center"
        >
          <div className="flex items-center justify-center">
            <span className="text-blue-700 px-3 py-1 rounded text-sm font-medium">
              {formatValue(expected)}
            </span>
          </div>
        </TableCell>
        <TableCell
          key={`${regionKey}-result`}
          sx={{
            borderBottom: "1px solid #f0f0f0",
            padding: "14px 10px",
            backgroundColor: bgColor,
          }}
          align="center"
        >
          <div className="flex items-center justify-center">
            {result === "-" ? (
              <span className="px-3 py-1 rounded text-sm font-medium">-</span>
            ) : (
              <span
                className={`px-3 py-1 rounded text-sm font-medium ${
                  result < 0
                    ? "bg-red-50 text-red-700 border border-red-100"
                    : "bg-green-50 text-green-700 border border-green-100"
                }`}
              >
                {formatValue(result)}
              </span>
            )}
          </div>
        </TableCell>
      </>
    );
  };

  if (props.tableType === "EstimativaReport") {
    return (
      <TableRow>
        <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={12}>
          <Box sx={{margin: 1, overflow: "auto"}}>
            <Table size="small" aria-label="quantidade">
              <TableHead>
                <TableRow
                  sx={{backgroundColor: "#f8fafc", minWidth: "1900px"}}
                >
                  <TableCell
                    className="min-w-[300px] md:min-w-[700px]"
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: 600,
                      color: "#047857",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      padding: "16px 12px",
                      borderBottom: "2px solid #d1fae5",
                    }}
                  >
                    <div className="flex items-center space-x-2">
                      <span className="w-3 h-3 bg-emerald-500 rounded-full"></span>
                      <span>{title}</span>
                    </div>
                  </TableCell>
                  <TableCell
                    sx={{
                      borderLeft: "2px solid #d1fae5",
                      fontSize: "0.875rem",
                      fontWeight: 600,
                      color: "#047857",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      minWidth: "120px",
                      padding: "16px 12px",
                      borderBottom: "2px solid #d1fae5",
                    }}
                    align="center"
                  >
                    Estimativa
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody
                sx={{backgroundColor: "#ffffff", minWidth: "1900px"}}
              >
                {row.map((historyRow, index) => (
                  <TableRow
                    key={historyRow.customerId || index}
                    className={`hover:bg-emerald-50 transition-colors duration-200 ${
                      index % 2 === 0 ? "bg-white" : "bg-gray-50"
                    }`}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#ecfdf5",
                      },
                    }}
                  >
                    <TableCell
                      sx={{
                        borderBottom: "1px solid #e5e7eb",
                        padding: "16px 12px",
                        fontWeight: 500,
                        color: "#374151",
                      }}
                    >
                      <div className="flex items-center space-x-3">
                        <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
                        <span className="text-gray-800">
                          {historyRow.customerId}
                        </span>
                      </div>
                    </TableCell>
                    <TableCell
                      sx={{
                        borderLeft: "1px solid #e5e7eb",
                        borderBottom: "1px solid #e5e7eb",
                        padding: "16px 12px",
                        fontWeight: 600,
                      }}
                      align="center"
                    >
                      <div className="flex items-center justify-center">
                        <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm font-semibold">
                          {formatValue(historyRow.value)}
                        </span>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </TableCell>
      </TableRow>
    );
  }

  return (
    <React.Fragment>
      <TableRow
        sx={{
          backgroundColor: "#fdfdfd",
          borderBottom: "1px solid #f0f0f0",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "#fafafa",
          },
        }}
        onClick={() => setMainCategoryOpen(!mainCategoryOpen)}
      >
        <TableCell
          component="th"
          scope="row"
          colSpan={12}
          sx={{
            padding: "0",
            width: "100%"
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              padding: "10px 6px",
            }}
          >
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setMainCategoryOpen(!mainCategoryOpen);
              }}
              className="p-0.5 transition-all duration-200"
              sx={{
                color: "#047857",
                backgroundColor: "transparent",
                border: "1px solid #e0e7e4",
                borderRadius: "4px",
                "&:hover": {
                  backgroundColor: "#f7f9f8",
                },
              }}
            >
              {mainCategoryOpen ? <Remove fontSize="small"/> : <Add fontSize="small"/>}
            </IconButton>
            <div className="flex items-center justify-between ml-2 w-full">
              <div className="flex items-center gap-x-2">
                <Typography
                  variant="subtitle1"
                  className="font-medium"
                  sx={{
                    color: "#065f46",
                    fontSize: "0.9rem",
                    letterSpacing: "0.01em",
                  }}
                >
                  {row.groupName}
                </Typography>
              </div>
            </div>
          </Box>
        </TableCell>
      </TableRow>

      {(row.subCategories && mainCategoryOpen) &&
        row.subCategories.map((subCategory, subCategoryIndex) => {
          const isOpen = openSubCategories[subCategory.className] || false;
          const isObservation = subCategory.className.slice(0, 10).toLowerCase() === 'observação'

          return (
            <React.Fragment key={`subcategory-${subCategory.className}-${subCategoryIndex}`}>
              <TableRow
                sx={{
                  backgroundColor: "#fdfdfd",
                  borderBottom: "1px solid #f0f0f0",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "#fafafa",
                  },
                }}
                onClick={() => toggleSubCategory(subCategory.className)}
              >
                <TableCell
                  component="th"
                  scope="row"
                  colSpan={12}
                  sx={{
                    padding: "0",
                    paddingLeft: "32px",
                    width: "100%"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      padding: "10px 6px",
                    }}
                  >
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleSubCategory(subCategory.className);
                      }}
                      className="p-0.5 transition-all duration-200"
                      sx={{
                        color: "#047857",
                        backgroundColor: "transparent",
                        border: "1px solid #e0e7e4",
                        borderRadius: "4px",
                        "&:hover": {
                          backgroundColor: "#f7f9f8",
                        },
                      }}
                    >
                      {isOpen ? <Remove fontSize="small"/> : <Add fontSize="small"/>}
                    </IconButton>
                    <div className="flex items-center justify-between ml-2 w-full">
                      <div className="flex items-center gap-x-2">
                        <Typography
                          variant="subtitle1"
                          className="font-medium"
                          sx={{
                            color: "#065f46",
                            fontSize: "0.9rem",
                            letterSpacing: "0.01em",
                          }}
                        >
                          {!isObservation ? subCategory.className : row.groupName}
                        </Typography>
                      </div>
                      <div className="flex items-center justify-end ml-auto">
                        <span className="text-gray-500 text-xs md:mr-4">
                          {subCategory.attributes.length} parâmetros
                        </span>
                      </div>
                    </div>
                  </Box>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={13}>
                  <Collapse in={isOpen} timeout="auto" unmountOnExit>
                    <Box sx={{margin: 1, overflow: "auto"}}>
                      <Table size="small" aria-label="quantidade">
                        <TableHead>
                          <TableRow sx={{margin: 1, overflow: "hidden"}}>
                            <TableCell
                              sx={{
                                fontWeight: 500,
                                width: "100%",
                                backgroundColor: "#f8fcf9",
                                color: "#065f46",
                                fontSize: "0.875rem",
                                textTransform: "uppercase",
                                letterSpacing: "0.03em",
                                padding: "14px 16px",
                                borderBottom: "1px solid #e0e7e4",
                                position: "relative",
                              }}
                              align="center"
                              colSpan={2}
                            >
                              <div className="flex items-center justify-center space-x-2">
                                <div className="w-2 h-2 rounded-full bg-emerald-400"></div>
                                <span className="font-medium">Parâmetro de Saúde</span>
                              </div>
                            </TableCell>
                            {props.showCityLevel && (
                              <TableCell
                                sx={{
                                  fontWeight: 500,
                                  backgroundColor: "#fff",
                                  color: "#3b5da6",
                                  fontSize: "0.75rem",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.03em",
                                  padding: "8px 10px",
                                  borderBottom: "1px solid #e0e7f0",
                                  borderLeft: "1px solid #f0f0f0",
                                }}
                                align="center"
                                colSpan={3}
                              >
                                <div className="flex items-center justify-center space-x-2">
                                  <div className="w-1.5 h-1.5 rounded-full bg-blue-400"></div>

                                  {!isObservation ?
                                    <span className="font-medium">
                                      Município ({props.city.selectedCity})
                                    </span>
                                    :
                                    <span className="font-medium">
                                      Observação ({props.city.selectedCity})
                                    </span>
                                  }

                                </div>
                              </TableCell>
                            )}
                            {props.showMicroLevel && !isObservation && (
                              <TableCell
                                sx={{
                                  fontWeight: 500,
                                  backgroundColor: "#fafbfc",
                                  color: "#3b5da6",
                                  fontSize: "0.75rem",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.03em",
                                  padding: "10px 14px",
                                  borderBottom: "1px solid #e4e0fc",
                                  borderLeft: "1px solid #f0f0f0",
                                }}
                                align="center"
                                colSpan={3}
                              >
                                <div className="flex items-center justify-center space-x-2">
                                  <div className="w-2 h-2 rounded-full bg-blue-400"></div>
                                  <span className="font-medium">
                                    Micro-Região ({props.city.selectedMicro})
                                  </span>
                                </div>
                              </TableCell>
                            )}
                            {props.showMacroLevel && !isObservation && (
                              <TableCell
                                sx={{
                                  fontWeight: 500,
                                  backgroundColor: "#f7f7f7",
                                  color: "#3b5da6",
                                  fontSize: "0.75rem",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.03em",
                                  padding: "10px 14px",
                                  borderBottom: "1px solid #f0f0f0",
                                  borderLeft: "1px solid #f0f0f0",
                                }}
                                align="center"
                                colSpan={3}
                              >
                                <div className="flex items-center justify-center space-x-2">
                                  <div className="w-2 h-2 rounded-full bg-blue-400"></div>
                                  <span className="font-medium">
                                    Macro-Região ({props.city.selectedMacro})
                                  </span>
                                </div>
                              </TableCell>
                            )}
                          </TableRow>
                          <TableRow
                            sx={{backgroundColor: "#fafbfc", minWidth: "1900px"}}
                          >
                            {props.tableType === "EstimativaReport" ? (
                              <>
                                <TableCell
                                  sx={{
                                    minWidth: "300px",
                                    fontWeight: 600,
                                    backgroundColor: "#f0fdf4",
                                    color: "#047857",
                                    fontSize: "0.875rem",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.05em",
                                    padding: "12px 16px",
                                    borderBottom: "2px solid #d1fae5",
                                  }}
                                >
                                  <div className="flex items-center space-x-2">
                                    <span className="w-3 h-3 bg-emerald-500 rounded-full"></span>
                                    <span>{title}</span>
                                  </div>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    borderLeft: "2px solid #d1fae5",
                                    fontWeight: 600,
                                    minWidth: "140px",
                                    backgroundColor: "#f0fdf4",
                                    color: "#047857",
                                    fontSize: "0.875rem",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.05em",
                                    padding: "12px 16px",
                                    borderBottom: "2px solid #d1fae5",
                                  }}
                                  align="center"
                                >
                                  Prevalência (%)
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontWeight: 600,
                                    minWidth: "120px",
                                    backgroundColor: "#f0fdf4",
                                    color: "#047857",
                                    fontSize: "0.875rem",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.05em",
                                    padding: "12px 16px",
                                    borderBottom: "2px solid #d1fae5",
                                  }}
                                  align="center"
                                >
                                  Estimativa
                                </TableCell>
                              </>
                            ) : (
                              <>
                                <TableCell
                                  sx={{
                                    minWidth: "300px",
                                    fontWeight: 500,
                                    backgroundColor: "#f8fcf9",
                                    color: "#065f46",
                                    fontSize: "0.875rem",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.03em",
                                    padding: "10px 14px",
                                    borderBottom: "1px solid #6EE7B7",
                                  }}
                                >
                                  <div className="flex items-center space-x-2">
                                    <span className="w-2 h-2 bg-emerald-400 rounded-full"></span>
                                    <span>Parâmetro</span>
                                  </div>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    borderLeft: "2px solid #e0e7e4",
                                    fontWeight: 600,
                                    minWidth: "120px",
                                    backgroundColor: "#f8fcf9",
                                    color: "#6366F1",
                                    fontSize: "0.75rem",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.03em",
                                    padding: "10px 12px",
                                    borderBottom: "1px solid #A5B4FC",
                                    textAlign: "center",
                                  }}
                                >
                                  <div className="flex items-center justify-center space-x-1">
                                    <span
                                      className={`w-1.5 h-1.5 rounded-full ${
                                        props.tableType === "DimensionamentoReport"
                                          ? "bg-indigo-500"
                                          : "bg-indigo-500"
                                      }`}
                                    ></span>
                                    <span className="font-medium">Ações</span>
                                  </div>
                                </TableCell>
                                {props.showCityLevel && (
                                  <TableCell
                                    sx={{
                                      borderLeft: "2px solid #f0f0f0",
                                      fontWeight: 600,
                                      minWidth: "120px",
                                      backgroundColor: "#fff",
                                      color: "#3b5da6",
                                      fontSize: "0.75rem",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.03em",
                                      padding: "10px 12px",
                                      borderBottom: "1px solid #b5c7fd",
                                    }}
                                    align="center"
                                  >
                                    <div className={`flex items-center justify-center space-x-1 ${isObservation && "hidden"}`}>
                                      <span
                                        className={`w-1.5 h-1.5 rounded-full ${
                                          props.tableType === "DimensionamentoReport"
                                            ? "bg-blue-500"
                                            : "bg-blue-500"
                                        }`}
                                      ></span>
                                      <span className="font-medium">Disponível</span>
                                    </div>
                                  </TableCell>
                                )}
                                {props.showCityLevel && !isObservation && (
                                  <TableCell
                                    sx={{
                                      fontWeight: 600,
                                      minWidth: "120px",
                                      backgroundColor: "#fff",
                                      color: "#3b5da6",
                                      fontSize: "0.75rem",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.03em",
                                      padding: "10px 12px",
                                      borderBottom: "1px solid #b5c7fd",
                                    }}
                                    align="center"
                                  >
                                    <div className="flex items-center justify-center space-x-1">
                              <span
                                className={`w-1.5 h-1.5 rounded-full ${
                                  props.tableType === "DimensionamentoReport"
                                    ? "bg-blue-500"
                                    : "bg-blue-500"
                                }`}
                              ></span>
                                      <span className="font-medium">Necessário</span>
                                    </div>
                                  </TableCell>
                                )}
                                {props.showCityLevel && (
                                  <TableCell
                                    sx={{
                                      fontWeight: 600,
                                      minWidth: "120px",
                                      backgroundColor: "#fff",
                                      color: "#3b5da6",
                                      fontSize: "0.75rem",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.03em",
                                      padding: "10px 12px",
                                      borderBottom: "1px solid #b5c7fd",
                                    }}
                                    align="center"
                                  >
                                    <div className={`flex items-center justify-center space-x-1 ${isObservation && "hidden"}`}>
                              <span
                                className={`w-1.5 h-1.5 rounded-full ${
                                  props.tableType === "DimensionamentoReport"
                                    ? "bg-blue-400"
                                    : "bg-blue-400"
                                }`}
                              ></span>
                                      <span className="font-medium">Suficiência</span>
                                    </div>
                                  </TableCell>
                                )}
                                {props.showMicroLevel && !isObservation && (
                                  <TableCell
                                    sx={{
                                      borderLeft: "2px solid #f0f0f0",
                                      fontWeight: 600,
                                      minWidth: "120px",
                                      backgroundColor: "#fafbfc",
                                      color: "#3b5da6",
                                      fontSize: "0.75rem",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.03em",
                                      padding: "10px 12px",
                                      borderBottom: "1px solid #b5c7fd",
                                    }}
                                    align="center"
                                  >
                                    <div className="flex items-center justify-center space-x-1">
                              <span
                                className={`w-1.5 h-1.5 rounded-full ${
                                  props.tableType === "DimensionamentoReport"
                                    ? "bg-blue-500"
                                    : "bg-blue-500"
                                }`}
                              ></span>
                                      <span className="font-medium">Disponível</span>
                                    </div>
                                  </TableCell>
                                )}
                                {props.showMicroLevel && !isObservation && (
                                  <TableCell
                                    sx={{
                                      fontWeight: 600,
                                      minWidth: "120px",
                                      backgroundColor: "#fafbfc",
                                      color: "#3b5da6",
                                      fontSize: "0.75rem",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.05em",
                                      padding: "10px 12px",
                                      borderBottom: "1px solid #b5c7fd",
                                    }}
                                    align="center"
                                  >
                                    <div className="flex items-center justify-center space-x-1">
                              <span
                                className={`w-1.5 h-1.5 rounded-full ${
                                  props.tableType === "DimensionamentoReport"
                                    ? "bg-blue-500"
                                    : "bg-blue-500"
                                }`}
                              ></span>
                                      <span className="font-medium">Necessário</span>
                                    </div>
                                  </TableCell>
                                )}
                                {props.showMicroLevel && !isObservation && (
                                  <TableCell
                                    sx={{
                                      fontWeight: 600,
                                      minWidth: "120px",
                                      backgroundColor: "#fafbfc",
                                      color: "#3b5da6",
                                      fontSize: "0.75rem",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.05em",
                                      padding: "10px 12px",
                                      borderBottom: "1px solid #b5c7fd",
                                    }}
                                    align="center"
                                  >
                                    <div className="flex items-center justify-center space-x-1">
                              <span
                                className={`w-1.5 h-1.5 rounded-full ${
                                  props.tableType === "DimensionamentoReport"
                                    ? "bg-blue-400"
                                    : "bg-blue-400"
                                }`}
                              ></span>
                                      <span className="font-medium">Suficiência</span>
                                    </div>
                                  </TableCell>
                                )}
                                {props.showMacroLevel && !isObservation && (
                                  <TableCell
                                    sx={{
                                      borderLeft: "2px solid #e5e7eb",
                                      fontWeight: 600,
                                      minWidth: "120px",
                                      backgroundColor: "#f7f7f7",
                                      color: "#3b5da6",
                                      fontSize: "0.75rem",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.05em",
                                      padding: "10px 12px",
                                      borderBottom: "1px solid #b5c7fd",
                                    }}
                                    align="center"
                                  >
                                    <div className="flex items-center justify-center space-x-1">
                              <span
                                className={`w-1.5 h-1.5 rounded-full ${
                                  props.tableType === "DimensionamentoReport"
                                    ? "bg-blue-500"
                                    : "bg-blue-500"
                                }`}
                              ></span>
                                      <span className="font-medium">Disponível</span>
                                    </div>
                                  </TableCell>
                                )}
                                {props.showMacroLevel && !isObservation && (
                                  <TableCell
                                    sx={{
                                      fontWeight: 600,
                                      minWidth: "120px",
                                      backgroundColor: "#f7f7f7",
                                      color: "#3b5da6",
                                      fontSize: "0.75rem",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.03em",
                                      padding: "8px 10px",
                                      borderBottom: "1px solid #b5c7fd",
                                    }}
                                    align="center"
                                  >
                                    <div className="flex items-center justify-center space-x-1">
                              <span
                                className={`w-1.5 h-1.5 rounded-full ${
                                  props.tableType === "DimensionamentoReport"
                                    ? "bg-blue-500"
                                    : "bg-blue-500"
                                }`}
                              ></span>
                                      <span className="font-medium">Necessário</span>
                                    </div>
                                  </TableCell>
                                )}
                                {props.showMacroLevel && !isObservation && (
                                  <TableCell
                                    sx={{
                                      fontWeight: 500,
                                      minWidth: "120px",
                                      backgroundColor: "#f7f7f7",
                                      color: "#3b5da6",
                                      fontSize: "0.75rem",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.03em",
                                      padding: "8px 10px",
                                      borderBottom: "1px solid #b5c7fd",
                                    }}
                                    align="center"
                                  >
                                    <div className="flex items-center justify-center space-x-1">
                              <span
                                className={`w-1.5 h-1.5 rounded-full ${
                                  props.tableType === "DimensionamentoReport"
                                    ? "bg-blue-400"
                                    : "bg-blue-400"
                                }`}
                              ></span>
                                      <span className="font-medium">Suficiência</span>
                                    </div>
                                  </TableCell>
                                )}
                              </>
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody
                          sx={{backgroundColor: "#ffffff", minWidth: "1900px"}}
                        >
                          {subCategory.attributes.map((historyRow, index) => {
                            const key = historyRow.customerId || historyRow.customerCode || `attr-${subCategoryIndex}-${index}`;
                            const cityRegion = {
                              available: historyRow.availableProvidersCity !== null ? historyRow.availableProvidersCity : historyRow.typeService,
                              expected: historyRow.expectedProvidersNeedsCity !== null ? historyRow.expectedProvidersNeedsCity : historyRow.typeService,
                              result: historyRow.resultAmountCity !== null ? historyRow.resultAmountCity : historyRow.typeService,
                            };

                            const microRegion = {
                              available: historyRow.availableProvidersMicro !== null ? historyRow.availableProvidersMicro : historyRow.typeService,
                              expected: historyRow.expectedProvidersNeedsMicro !== null ? historyRow.expectedProvidersNeedsMicro : historyRow.typeService,
                              result: historyRow.resultAmountMicro !== null ? historyRow.resultAmountMicro : historyRow.typeService,
                            };

                            const macroRegion = {
                              available: historyRow.availableProvidersMacro !== null ? historyRow.availableProvidersMacro : historyRow.typeService,
                              expected: historyRow.expectedProvidersNeedsMacro !== null ? historyRow.expectedProvidersNeedsMacro : historyRow.typeService,
                              result: historyRow.resultAmountMacro !== null ? historyRow.resultAmountMacro : historyRow.typeService,
                            };
                            return (
                              <TableRow
                                key={key}
                                className={`transition-colors duration-200 ${
                                  index % 2 === 0 ? "bg-white" : "bg-gray-50"
                                }`}
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "#fafafa",
                                  },
                                }}
                              >
                                <TableCell
                                  sx={{
                                    padding: "14px 16px",
                                    fontWeight: 500,
                                    color: "#374151",
                                    borderBottom: "1px solid #f0f0f0",
                                  }}
                                >
                                  <div className="flex items-center space-x-2">
                                    <div className="w-1.5 h-1.5 bg-emerald-400 rounded-full flex-shrink-0"></div>
                                    <span className="text-gray-700">
                                        {historyRow.customerId}
                                      </span>
                                  </div>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    borderLeft: "1px solid #e5e7eb",
                                    padding: "14px 16px",
                                    fontWeight: 500,
                                    color: "#374151",
                                    borderBottom: "1px solid #f0f0f0",
                                  }}
                                >
                                  <div className="flex justify-center items-center gap-x-4">
                                    <IconButton
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        historyRow.expectedProvidersNeedsCity !== null &&
                                        handleOpenMap(historyRow.customerId, historyRow.customerCode, city.selectedState);
                                      }}
                                    >

                                      <FaMapMarkedAlt
                                        className={`text-indigo-500 hover:text-indigo-700 transition-colors duration-150 ease-in-out cursor-pointer text-xl ${
                                          historyRow.expectedProvidersNeedsCity === null ? "opacity-50 cursor-not-allowed pointer-events-none" : ""
                                        }`}
                                        title="Ver Suficiência do Parâmetro no Estado Inteiro"/>
                                    </IconButton>
                                  </div>
                                </TableCell>

                                {props.showCityLevel &&
                                  renderRegionCells(
                                    cityRegion,
                                    "#fff",
                                    `city-${index}`
                                  )}

                                {props.showMicroLevel && !isObservation &&
                                  renderRegionCells(
                                    microRegion,
                                    "#fafbfc",
                                    `micro-${index}`
                                  )}

                                {props.showMacroLevel && !isObservation &&
                                  renderRegionCells(
                                    macroRegion,
                                    "#f7f7f7",
                                    `macro-${index}`
                                  )}
                              </TableRow>
                            )
                          })
                          }
                        </TableBody>
                      </Table>
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            </React.Fragment>
          )
        })
      }

      {mapModalOpen && (
        <MapModal
          open={mapModalOpen}
          onClose={() => setMapModalOpen(false)}
          data={mapData}
          state={city.selectedState}
          parameterName={selectedCustomer}
        />)}

    </React.Fragment>
  );
}